import {utilHelper} from "../../_helpers";
import {SUCCESSFUL_TRANSLATION_LABEL} from "../../../components/i18n/i18n";

const relativeUrl = 'api/FiltersMap'

export const filtersMapService = {
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    search,
    getOptions,
    translate
};

function getOptions(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/getOptions`, 'POST', { data:data, showAlert:false })
}

function search(offset, max, dataFilter) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: dataFilter, showAlert: false  })
}

function getItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'GET', { showAlert: false })
}

function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data  });
}

function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data: data  });
}

function deleteItem(id, fbDB) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${fbDB}`, 'DELETE', {})
}

function translate(id, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/translate/${id}`, 'POST', { data: data, message:SUCCESSFUL_TRANSLATION_LABEL });
}